@if (cashbackAmount()) {
  @if (!hideAnnualCosts()) {
    <div
      class="d-flex justify-content-between mb-1"
      wlAutomationId="order-overview-budget-bill-before-discount"
    >
      <div><span *scText="beforeDiscountYearlyLabel()" wlCSCapture></span></div>
      <div class="text-end">
        <span wlCSCapture>
          {{ beforeDiscountYearlyAmount() | roundedCurrency }}
        </span>
      </div>
    </div>
  }
  <div
    class="d-flex justify-content-between text-success mb-1 budget-bill-cashback-row"
    wlAutomationId="order-overview-budget-bill-cashback"
  >
    <div
      [ngClass]="
        termijnbedragVariantA() || termijnbedragVariantB()
          ? 'budget-bill-cashback-label-variant-ab'
          : ''
      "
    >
      <span *scText="cashbackLabel()" wlCSCapture></span>
    </div>
    <div class="text-end">
      <span wlCSCapture> - {{ cashbackAmount() | roundedCurrency }} </span>
    </div>
  </div>
}

@if (promoCode(); as promoCode) {
  <div class="rounded-3 my-1 promocode">
    {{ promoCode }}
  </div>
}

@if (!hideAnnualCosts() && !showCostsInHeader()) {
  <div class="d-flex justify-content-between fw-bold mb-1">
    <div>
      <span wlCSCapture>{{ yearlyLabel() }}</span>
      @if (
        (termijnbedragVariantA() || termijnbedragVariantB()) && cashbackAmount()
      ) {
        <span>{{ costsWithDiscountLabel() }}</span>
      }
    </div>
    <div
      class="text-end"
      [ngClass]="
        termijnbedragVariantA() || termijnbedragVariantB() ? 'text-success' : ''
      "
    >
      <span wlCSCapture>
        {{ yearlyAmount() | roundedCurrency }}
      </span>
    </div>
  </div>
}

<div [class.budget-bill-monthly-costs-hidden-mobile]="showCostsInHeader()">
  <hr />

  <div class="d-flex flex-column">
    @if (!termijnbedragVariantA()) {
      <ng-container
        *ngTemplateOutlet="monthlyAmountSegmentTemplate"
      ></ng-container>
    }
    @if (!enableRemoveBBA()) {
      <div class="d-flex justify-content-between">
        <div>
          <span *wlGenericRichText="budgetBillLabel()" wlCSCapture></span>
          @if (!!budgetBillTooltip()) {
            <wl-tooltip
              [tooltip]="{
                description: budgetBillTooltip(),
              }"
              class="ps-1"
            >
            </wl-tooltip>
          }
        </div>
        <span class="ps-1" wlCSCapture>{{
          budgetBillAmount() | roundedCurrency
        }}</span>
      </div>
    }
    @if (termijnbedragVariantA()) {
      <ng-container
        *ngTemplateOutlet="monthlyAmountSegmentTemplate"
      ></ng-container>
    }
  </div>
</div>

<ng-template #monthlyAmountSegmentTemplate>
  <div class="d-flex justify-content-between align-items-baseline">
    <div>
      <span
        *wlGenericRichText="monthlyAmountLabel()"
        class="fw-bold"
        wlCSCapture
      ></span>
      @if (
        (termijnbedragVariantA() || termijnbedragVariantB()) && cashbackAmount()
      ) {
        <span class="fw-bold">{{ costsWithDiscountLabel() }}</span>
      }

      @if (!!monthlyAmountTooltip) {
        <wl-tooltip
          [tooltip]="{
            description: monthlyAmountTooltip(),
          }"
          class="ps-1"
        >
        </wl-tooltip>
      }
      @if (
        termijnbedragVariantA() &&
        monthlyAmountAdditionalLabel().length &&
        cashbackAmount()
      ) {
        <div class="lh-sm monthly-amount__additional-label">
          <span>{{ monthlyAmountAdditionalLabel() }}</span>
        </div>
      }
    </div>
    <span
      class="monthly-amount__amount h3 ps-1"
      [ngClass]="
        termijnbedragVariantA() || termijnbedragVariantB()
          ? 'text-success'
          : 'text-brand'
      "
      wlCSCapture
      >{{ monthlyAmount() | roundedCurrency }}</span
    >
  </div>
</ng-template>
